import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da68ccd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("生成工资发放清单")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出未生成工资员工")
const _hoisted_6 = { class: "limitLength" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

  
const __default__ = {
  name: 'salarySummary'
}
import {ref, Ref, computed, onMounted, onActivated } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { useRoute } from 'vue-router'
import { formatNumber, getNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {
  // 工资汇总清单
  'GET/payroll/summary/query_summary': fetchList,
  // 工资发放清单_多批统计
  'POST/payroll/summary/query_summaries': fetchLists,
  // 生成工资发放清单
  'POST/payroll/summary/generate': generateApi,
  // 获取员工已有银行
  'GET/banks/drop_list': drop_listApi,
  // 'POST/banks/list': banksListApi,
  // 工资发放清单生成记录_解锁
  'PUT/payroll/detail_record/locked': lockedApi,
  // 导出未生成工资发放清单人员名单
  'POST/payroll/summary/missing': missingApi,
} = Api

const route = useRoute()
const btnLoadFg = ref<boolean>(false)
let salaryRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(route.params.multi === 'singleSmy' ? fetchList : fetchLists)
// } = new tbMix(fetchList)

let bankSummary: any = ref([])
onActivated(() => {
  
/*   bankSummary.value = []
  Object.assign(MI_params, route.params)
  searchHandle() */
})

const searchHandle = () => {
  fetchData(MI_params).then(rep => {
    // 获取各公司银行汇总
    let { payBankSummaryList } = rep
    bankSummary.value = payBankSummaryList
    
    // 计算各公司合计
    MI_tableData.value.map((company) => {
      // 从payBankSummaryList中，获取对应公司的Array
      let amountArr = payBankSummaryList.filter((bank: any) => bank.companyName === company.companyName)
      company.amount = amountArr.reduce((number: number, bank: any) => {
        company[bank.bankName === 'Invalid' ? '未选发放行': bank.bankName ] = bank.payAmountSum
        number += bank.payAmountSum
        return number
      }, 0)
    })
  })
}
// 银行去重
const bankTitle = computed(() => {
  let bankStrArr: string[] = bankSummary.value.map((bank: any) => {
    return bank.bankName === 'Invalid' ? '未选发放行' : bank.bankName
  })
  return [...new Set(bankStrArr)]
})

let bankList: any = ref([])
onMounted(() => {
  // 获取银行列表，用于设置优先级
  drop_listApi().then((banks: any) => {
    bankList.value = banks.aliasList.map((bank: string) => {
      return {fullName: bank, id: bank}
    })
  })

  bankSummary.value = []
  Object.assign(MI_params, route.params)
  searchHandle() 
})


const sortBankFg = ref<boolean>(false)
let bankCardLevel: any = ref([])
const sortBank = () => {
  if(salaryRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  sortBankFg.value = true
}

const bankCardLevelMap = computed(() => {
  if(bankCardLevel.value.length === 0){
    // 返回默认顺序
    return bankList.value.reduce((obj: any, bank: any, index: number) => {
      obj[index + 1] = bank.fullName
      return obj
    }, {})
  }
  // 从完整银行列表获取银行名称
  return bankCardLevel.value.reduce((obj: any, bankId: number, index: number) => {
    obj[index + 1] = bankList.value.find((bank: any) => bank.id == bankId).fullName
    return obj
  }, {})
})

// 生成工资发放清单
const submitHandle = async () => {
  if(route.params.multi === 'mulSmy')return;
  if(bankCardLevel.value.length === 0){
    try {
      await ElMessageBox.confirm(
        '是否使用默认顺序?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
    } catch (error) {
      return
    }
  }

  btnLoadFg.value = true
  generateApi({
    distributeId: route.params.distributeId as any,
    bankCardLevel: bankCardLevelMap.value,
    companyIdList: salaryRows.value.map((e : {companyId: number}) => e.companyId)
  }).then(() => {
    btnLoadFg.value = false
    ElMessage.success('生成工资发放清单成功')
    sortBankFg.value = false
    bankCardLevel.value = []
  }).catch(() => {
    btnLoadFg.value = false
    return 
  })
}
// 跳转查看明细
const bankClick = (row: any, column: any) => {
  if(route.params.multi === 'mulSmy')return;
  const exceptedColumn = ['companyName', 'actualSalarySum', 'salarySum', 'filialSum', 'amount']
  if(exceptedColumn.includes(column['property'])) return;

  router.push({
    path: '/respective-distribution',
    query: {
      distributeId: route.params.distributeId,
      companyName: row.companyName,
      payBank: column['property'] === '未选发放行' ? 'Invalid' : column['property'] 
    },
  })
}

// 解锁
const unlockHandle = () => {
  if(salaryRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }

  ElMessageBox.confirm(
    '是否确认解锁?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    return lockedApi({
      locked: 0,
      companyIdList: salaryRows.value.map((e : {companyId: number}) => e.companyId),
    })
  }).then(() => {
    ElMessage.success('成功')
    // fetchData(MI_params)
    searchHandle()
  }).catch(() => {})
}

// 导出未生成员工
const exportUngenerateHandle = () => {
  if(salaryRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return false
  }
  MI_identify.value = true
  exportHandle(missingApi, {
    distributeId: route.params.distributeId,
    companyIdList: salaryRows.value.map((e: any) => e.companyId)
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('下载成功')
  }).catch(() => {
    MI_identify.value = false
  })
}


// 合计
const getSalarySummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: number) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
    const values = data.map((item: any) => Number(item[column.property]))
    if (!values.every((value: any) => Number.isNaN(value))) {
      sums[index] = getNumber(values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
    } else {
      sums[index] = '-'
    }
  })
  return sums
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", null, "当前发放清单:" + _toDisplayString(_ctx.$route.params.name), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'distributionList'})))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      (_unref(route).params.multi === 'singleSmy')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (sortBank()))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })), [
            [_directive_permission, 'Create']
          ])
        : _createCommentVNode("", true),
      (_unref(route).params.multi === 'singleSmy')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (unlockHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })), [
            [_directive_permission, 'Write']
          ])
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "mr-10",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (exportUngenerateHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (searchHandle())),
        icon: "refresh"
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      "show-summary": "",
      data: _unref(MI_tableData),
      onCellClick: bankClick,
      onSelectionChange: _cache[5] || (_cache[5] = (rows) => _isRef(salaryRows) //@ts-ignore
 ? salaryRows.value = rows : salaryRows = rows),
      "summary-method": getSalarySummaries,
      "max-height": _unref(MI_height) - 70 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          width: "240",
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "140",
          align: "right",
          formatter: _unref(formatNumber),
          label: "实发合计",
          prop: "actualSalarySum",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "140",
          align: "right",
          formatter: _unref(formatNumber),
          label: "工资卡",
          prop: "salarySum",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "140",
          align: "right",
          formatter: _unref(formatNumber),
          label: "尽孝金",
          prop: "filialSum",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bankTitle), (bank) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            width: "140",
            align: "right",
            key: bank,
            label: bank,
            prop: bank,
            "show-overflow-tooltip": "",
            formatter: _unref(formatNumber)
          }, {
            header: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(bank), 1)
            ]),
            _: 2
          }, 1032, ["label", "prop", "formatter"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "合计",
          prop: "amount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      title: "银行卡优先级",
      modelValue: sortBankFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((sortBankFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: btnLoadFg.value,
          type: "primary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (submitHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_transfer, {
          filterable: "",
          titles: ['待选择银行', '优先顺序'],
          "target-order": "push",
          modelValue: _unref(bankCardLevel),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(bankCardLevel) ? (bankCardLevel).value = $event : bankCardLevel = $event)),
          data: _unref(bankList),
          props: {key: 'id', label: 'fullName'}
        }, null, 8, ["modelValue", "data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})